import service from "./../../../services/warehouse/warehouse"
import { arrayPushOrUpdateByID } from './../../../utils/toolkit';

export default {
    namespaced: true,
    state: {
        data: [],
        loading: false
    },
    getters: {
        loading: (state) => state.loading,
        data: (state) => state.data
    },
    mutations: {
        setLoading: (state, payload) => state.loading = payload,
        push: (state, payload) => state.data = arrayPushOrUpdateByID(state.data, payload)
    },
    actions: {
        get(context, payload) {
            return new Promise((resolve, reject) => {
                context.commit("setLoading", true);
                service.search(payload).then(response => {
                    context.commit("push", response.data);
                    resolve(response)
                }).catch(error => {
                    reject(error)
                }).finally(() => {
                    context.commit("setLoading", false)
                })

            })
        },
        push(context, payload) {
            context.commit("push", [payload]);
        }
    }
}